<template>
  <div v-if="orderList">
    <div class="list-block media-list" v-for="(order,index) in orderList" style="margin-bottom: 3rem" v-if="sessionInfo.customerInfo.ssoFlag === 0">
      <ul>
        <li v-if='order.merchandises'>
          <div class="item-inner" style="border-bottom: 3px solid ghostwhite">
            <span style="color:black; font-size: 0.7rem; margin-left: 0.2rem" v-if='order.selfOperated === 0'>第三方</span>
            <span style="color:black; font-size: 0.7rem; margin-left: 0.2rem" v-if='order.selfOperated === 1'>吉凯基因</span>
            <span style="color:gray; font-size: 0.8rem; float: right">{{order.status === 2 && order.researchGroupApproveResult === waitApproveStatus ? '待审批' : description}}</span>
          </div>
          <router-link :to="{ name: 'myOrderDetail', query: { BOrder: JSON.stringify(order)}}" class="item-link item-content"  v-if="order.subOrders.length === 0 ">
            <div class="item-inner" style="border-bottom: 1px solid gray;">
              <div class="item-media">
                <div v-for="merchandise in order.merchandises">
                  <img
                    :src="baseurl + merchandise.merchandiseDetailForClient.merchandiseIcon"
                    style='width: 4rem;margin-left: 0.1rem;'>
                  <div style="font-size: .2rem;text-align: center" v-if="merchandise.merchandiseDetailForClient.categoryId === 10">
                    <span v-if="merchandise._titleList[0].valueText !== '-1' && merchandise._titleList[0].valueText">{{merchandise._titleList[0].valueText}}</span>
                    <span v-if=" merchandise._titleList[1] && merchandise._titleList[1].valueText && merchandise._titleList[1].valueText !== '-1' ">{{merchandise._titleList[1].valueText}}</span>
                  </div>
                  <div style="font-size: .2rem;text-align: center" v-else><span v-if="merchandise._titleList[0].valueText !== '-1'">{{merchandise._titleList[0].valueText}}</span></div>
                </div>
              </div>
            </div>
          </router-link>
          <div  v-for="suborder in order.subOrders" v-if="order.subOrders.length > 0 " >
          <router-link :to="{ name: 'myOrderDetail', query: { BOrder: JSON.stringify(order)}}" class="item-link item-content" >
            <div class="item-inner" style="border-bottom: 1px solid gray;">
              <div class="item-media" >
                  <div v-for="merch in suborder.merchandises ">
                    <img
                      :src="baseurl + merch.merchandiseDetailForClient.merchandiseIcon"
                      style='width: 4rem;margin-left: 0.2rem;'>
                    <div style="font-size: .2rem;text-align: center" v-if="merch.merchandiseDetailForClient.categoryId === 10">
                      <span v-if="merch._titleList[0].valueText !== '-1'">{{merch._titleList[0].valueText}}}</span>
                      <span v-if="merch._titleList[1].valueText !== '-1'">{{merch._titleList[1].valueText}}</span>
                    </div>
                    <div style="font-size: .2rem;text-align: center" v-else><span v-if="merch._titleList[0].valueText !== '-1'">
                      {{merch._titleList[0].valueText}}  </span>  </div>
                    <div v-if="merch && merch.selfOperated === 0" style=" margin-top: 10px;">
                      <span style="font-size: x-small;color: #1482E7">【第三方】</span>
                    </div>
                  </div>
              </div>
              </div>
          </router-link>
          </div>
          <div class="item-inner">
            <div style="color:black; font-size: 0.7rem;text-align: right" v-if="order.isStock ">
              共{{order.productNum}}个商品 <span style="margin-left:1rem"> 实支付：</span>
              <span style="font-size: 1.2rem">{{order.totalPrice | currencyStyle}}</span>
            </div>
            <div style="color:black; font-size: 0.7rem;text-align: right" v-if=" order.isStock === false ">
              共{{order.productNum}}个商品 <span style="margin-left:1rem"> 实支付：</span>
              <span style="font-size: 1.2rem">{{order.totalPrice | currencyStyle}}</span>
            </div>
          </div>
          <div>
            <span v-if="order.status === 11 && order.merchandises[0].categoryId === 20 && (order.merchandises[0]._attributes.ReguTech === undefined || order.merchandises[0]._attributes.ReguTech.value !== '5')" class="orderBtn" @click="buyAgain1(order)" style="    color: white;
    background: rgb(0, 70, 154);">我要扩增</span>
          <span v-if="order.status === 2||3" class="orderBtn" @click="response1(order)"><img class="position" :src="button1Name"></span>
            <span v-if="order.researchGroupApproveResult !== waitApproveStatus" class="orderBtn" @click="response2(order)"><img class="pay-btn" :src="button2Name"></span>
          </div>
          <!--<div class="item-media" style="margin: 0 0 0 78%">-->
            <!--<section class="gotopay">-->
                        <!--<span class="gotopay_button_style" style="color: #fff; background: red"-->
                              <!--@click="addCartList(order.merchandises)">再次购买</span>-->
            <!--</section>-->
          <!--</div>-->
        </li>
      </ul>
    </div>
    <div class="list-block media-list" v-for="(order,index) in orderList" style="margin-bottom: 3rem"  v-if="sessionInfo.customerInfo.ssoFlag === 1">
      <ul>
        <li v-if='order.merchandises'>
            <div class="item-inner" style="border-bottom: 1px solid gray;">
              <div v-for="merchandise in order.merchandises">
                <a @click="response3(merchandise)">
                <div >

                  <img
                    :src="baseurl + merchandise.merchandiseDetailForClient.merchandiseIcon"
                    style='width: 4rem;margin-left: 0.1rem;'>
                  <div style="font-size: .2rem;margin-left: 0.1rem;color: black" v-if="merchandise.merchandiseDetailForClient.categoryId === 10">
                    <span v-if="merchandise._titleList[0].valueText !== '-1' && merchandise._titleList[0].valueText">{{merchandise._titleList[0].valueText}}</span>
                    <span v-if=" merchandise._titleList[1] && merchandise._titleList[1].valueText && merchandise._titleList[1].valueText !== '-1' ">{{merchandise._titleList[1].valueText}}</span>
                  </div>
                  <div style="font-size: .2rem;margin-left: 1rem;color: black" v-else><span v-if="merchandise._titleList[0].valueText !== '-1'">{{merchandise._titleList[0].valueText}}</span></div>

                </div>
                </a>
              </div>
            </div>
          <div class="item-inner">
            <div style="color:black; font-size: 0.7rem;text-align: right" v-if="order.isStock ">
              共{{order.productNum}}个商品 <span style="margin-left:1rem"> 实支付：</span>
              <span style="font-size: 1.2rem">{{order.totalPrice | currencyStyle}}</span>
            </div>
            <div style="color:black; font-size: 0.7rem;text-align: right" v-if=" order.isStock === false ">
              共{{order.productNum}}个商品 <span style="margin-left:1rem"> 实支付：</span>
              <span style="font-size: 1.2rem">{{order.totalPrice - order.expressPrice | currencyStyle}}</span>
            </div>
            <span style="font-size: xx-small;margin-left: 120px" v-if="order.merchandises[0].categoryId === 10 && order.orderNo">订单编号： {{order.orderNo}}</span>
          </div>

          <div>
            <span v-if="order.status === 11 && order.merchandises[0].categoryId === 20 && (order.merchandises[0]._attributes.ReguTech === undefined || order.merchandises[0]._attributes.ReguTech.value !== '5')" class="orderBtn" @click="buyAgain1(order)" style="color: #00469A">我要扩增</span>
            <span v-if="(order.status === 2||3) && button1Name " class="orderBtn" @click="response1(order)"><img class="position" :src="button1Name"></span>
            <span v-if="order.researchGroupApproveResult !== waitApproveStatus && button2Name" class="orderBtn" @click="response2(order)"><img class="pay-btn" :src="button2Name"></span>
            <span v-if="order.isStock === false " class="orderBtn"style="background: #00469A" @click="response4(order.priceDetails)">{{button3Name}}</span>
            <span v-if="order.audit.comments" class="orderBtn"  style="background: #00469A" @click="response5(order.audit.comments)">{{button4Name}}</span>
            <span v-if="order.sfQuoteStatus === 1" class="orderBtn"  style="background: #00469A" @click="response6(order.merchandises)" >{{button5Name}}</span>
          </div>
          <!--<div class="item-media" style="margin: 0 0 0 78%">-->
          <!--<section class="gotopay">-->
          <!--<span class="gotopay_button_style" style="color: #fff; background: red"-->
          <!--@click="addCartList(order.merchandises)">再次购买</span>-->
          <!--</section>-->
          <!--</div>-->
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import {mapState, mapMutations} from 'vuex'
  import EMKT from '../../../../emkt'
  export default {
    data () {
      return {
        baseurl: '/emktResources/resocurces/img/merchandise/',
        ordernum: [],
        waitApproveStatus: EMKT.RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE
      }
    },
    mounted () {
      $.showPreloader('加载中')
      setTimeout(function () {
        $.hidePreloader()
      }, 2000)
    },
    created () {
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ])
    },
    props: ['orderList', 'description', 'button1Name', 'button2Name', 'button3Name', 'button4Name', 'button5Name', 'payFlag'],
    methods: {
      ...mapMutations([
        'ADD_CART_LIST', 'REMOVE_FROM_CART_LIST'
      ]),
      buyAgain1 (order) {
        var order1 = {
        }
        order1 = order.merchandises[0].merchandiseDetailForClient
        order1.amplification = 1
//        order.merchandises[0].amplification = 1
        order1.amplification = 1
        if (typeof order1._attributes.TVInfo.value === 'string') {
          var obj = {}
          obj.TLNo = order1._attributes.TVInfo.value
          if (order1._attributesList[0].columnName === 'TVInfo') {
            order1._attributesList[0].value = obj
            order1._attributesList[0].valueText = obj
          }
        }
        for (var i in order1._attributesList) {
          if (order1._attributesList[i].value !== '214' && (order1._attributesList[i].columnName === 'AAVBloodType' || order1._attributesList[i].columnName === 'VirusTiter' || order1._attributesList[i].columnName === 'LVAmount' || order1._attributesList[i].columnName === 'NC_LV_Amount' || order1._attributesList[i].columnName === 'NC_LV_Amount' || order1._attributesList[i].columnName === 'NC_Lentivirus_Required' || order1._attributesList[i].columnName === 'NC_Plasmid_Amount' || order1._attributesList[i].columnName === 'NC_Plasmid_CultureRequired' || order1._attributesList[i].columnName === 'NC_Plasmid_Required' || order1._attributesList[i].columnName === 'PlasmidNumber' || order1._attributesList[i].columnName === 'Plasmid_Required' || order1._attributesList[i].columnName === 'Plasmid_Amount' || order1._attributesList[i].columnName === 'Plasmid_CultureRequired')) {
          } else {
            if ((order1._attributesList[i].groupId === 2 || order1._attributesList[i].groupId === 3) && order1._attributesList[i].columnName !== 'GeneInfo') {
              order1._attributesList[i].displayable = 0
            }
            order1._attributesList[i].sorteditAble = false
          }
          if (order1._attributesList[i].columnName === 'ContractType') {
            order1._attributesList[i].value = 3
            order1._attributesList[i].valueText = 3
          }
          if (order1._attributesList[i].columnName === 'Type' || order1._attributesList[i].columnName === 'Tech') {
            order1._attributesList[i].value = '-1'
            order1._attributesList[i].valueText = '-1'
            order1._attributes.Type.value = '-1'
            order1._attributes.Type.valueText = '-1'
          }
          if (order1._attributesList[i].columnName === 'PreContract') {
            order1._attributesList[i].value = order.contractNo + ':' + order.productName
            order1._attributesList[i].valueText = order.contractNo + ':' + order.productName
          }
          if (order1._attributesList[i].columnName === 'Source') {
            if (order1._attributes.ToolType.value === '3' || order1._attributes.ToolType.value === 3) {
              order1._attributesList[i].value = 4
              order1._attributesList[i].valueText = 4
            } else {
              order1._attributesList[i].value = 3
              order1._attributesList[i].valueText = 3
            }
          }
          if (order1._attributesList[i].columnName === 'PlasmidNumber') {
            if (order1._attributes.ToolType.value === '2' || order1._attributes.ToolType.value === 2) {
              if (order1._attributes.TargetNum.value === '-1' || order1._attributes.TargetNum.value === -1) {
                order1._attributesList[i].value = 1
                order1._attributesList[i].valueText = 1
              } else {
                order1._attributesList[i].value = order1._attributes.TargetNum.value
                order1._attributesList[i].valueText = order1._attributes.TargetNum.valueText
              }
            }
            if (order1._attributes.ToolType.value === '3' || order1._attributes.ToolType.value === 3) {
              order1._attributesList[i].value = 1
              order1._attributesList[i].valueText = 1
            }
          }
          if (order1._attributesList[i].columnName === 'VirusTiter') {
            if (order1._attributes.ProductName.value === 'RNAi综合－腺相关病毒外筛') {
              order1._attributesList[i].value = 3
              order1._attributesList[i].valueText = 3
            }
          }
          if (order1._attributesList[i].columnName === 'Plasmid_Amount') {
            if (order1._attributes.ProductName.value === '过表达慢病毒（Tet-on）' || order1._attributes.ProductName.value === '过表达慢病毒' || order1._attributes.ProductName.value === '过表达慢病毒（悬浮细胞专用）') {
              order1._attributesList[i].value = '-1'
              order1._attributesList[i].valueText = '-1'
            }
          }
          if (order1._attributesList[i].columnName === 'NC_LV_Amount') {
            if (order1._attributes.ProductName.value === 'CAS9-Easy-慢病毒(单载体)' || order1._attributes.ProductName.value === 'CAS9-Easy-慢病毒(双载体)' || order1._attributes.ProductName.value === 'CAS9-定制-慢病毒(SAM)' || order1._attributes.ProductName.value === 'CAS9-定制-慢病毒(单载体)' || order1._attributes.ProductName.value === 'CAS9-定制-慢病毒(双载体)') {
              order1._attributesList[i].value = '-1'
              order1._attributesList[i].valueText = '-1'
            }
          }
          if (order1._attributesList[i].columnName === 'GeneInfo.category') {
            if (order1._attributes.ProductName.value === 'miRNA-down-腺相关病毒' || order1._attributes.ProductName.value === 'miRNA-up-腺相关病毒') {
              order1._attributesList[i].value = '-1'
              order1._attributesList[i].valueText = '-1'
            }
          }
        }
        if (order1._attributes.ProductName.value === 'CAS9-Easy-慢病毒(SAM)' || order1._attributes.ProductName.value === 'CAS9-Easy-慢病毒(SAM,sgRNA)' || order1._attributes.ProductName.value === 'CAS9-Easy-慢病毒(单载体)' || order1._attributes.ProductName.value === 'CAS9-Easy-慢病毒(双载体)' || order1._attributes.ProductName.value === 'CAS9-Easy-慢病毒(双载体,sgRNA)' || order1._attributes.ProductName.value === 'RNAi-Easy(三保一)-慢病毒' || order1._attributes.ProductName.value === 'RNAi-Easy(三保一)-腺病毒' || order1._attributes.ProductName.value === 'RNAi-Easy-慢病毒（悬浮细胞专用）' || order1._attributes.ProductName.value === 'RNAi-Easy-逆转录病毒（悬浮细胞专用）') {
          alert('原订单为三个靶点，本次扩增产品只扩增其中您验证有效的靶点，且需要您提供有效靶点信息。如有疑问，请联系在线客服。')
        }
        this.$router.push({name: 'finderMerchandises', query: {categoryId: order1.categoryId}, params: {merchandises: order1}})
      },
      response1 (order) {
        this.$emit('response1', order)
      },
      response2 (order) {
        this.$emit('response2', order)
      },
      response3 (merchandise) {
        if (merchandise.merchandiseDetailForClient.categoryId !== 10) {
          this.$router.push({name: 'merchandises', query: { id: merchandise.merchandiseGuid }})
        } else {
          this.$router.push({name: 'custDetail', query: {custom: merchandise._attributesList, workdays: merchandise.workdays}})
        }
      },
      response4 (priceDetails) {
        this.$router.push({name: 'custPriceDetail', query: {priceDetails: priceDetails}})
      },
      response6 (merchandises) {
        for (var m in merchandises) {
          merchandises[m].merchandiseDetailForClient.id = merchandises[m].orderGuid
          merchandises[m].merchandiseDetailForClient.merchandiseId = merchandises[m].orderGuid
          this.REMOVE_FROM_CART_LIST(merchandises[m].merchandiseDetailForClient.merchandiseId)
          this.ADD_CART_LIST(merchandises[m].merchandiseDetailForClient)
        }
        this.$router.push({name: 'cart'})
      },
      response5 (comments) {
        $.modal({
          title: '审核意见',
          afterText: '<div style="margin-top: 10px">' + comments + '</div>',
          buttons: [
            {
              text: '确定',
              bold: true,
              onClick: function () {
              }
            }
          ]
        })
      }
    },
    filters: {
      currencyStyle (val) {
        return ' ¥ ' + val
      }
    }
  }
</script>
<style scoped>
  .orderBtn {
    color: white;
    text-align: center;
    /*background: #00469A;*/
    width: 3.5rem;
    float: right;
    margin: 0.2rem 0 0 0.6rem;
  }

  .position {
    position: relative;
    width: 3.8rem;
  }

  .pay-btn {
    margin-top: -0.04rem;
    width: 4.1rem;
  }
</style>




// WEBPACK FOOTER //
// MyOrder.vue?54db3e0e